var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFillAddCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1C6.15044 1.02238 4.38293 1.76706 3.075 3.075C1.76706 4.38293 1.02238 6.15044 1 8C1.02238 9.84956 1.76706 11.6171 3.075 12.925C4.38293 14.2329 6.15044 14.9776 8 15C9.84956 14.9776 11.6171 14.2329 12.925 12.925C14.2329 11.6171 14.9776 9.84956 15 8C14.9776 6.15044 14.2329 4.38293 12.925 3.075C11.6171 1.76706 9.84956 1.02238 8 1ZM12 8.5H8.5V12H7.5V8.5H4V7.5H7.5V4H8.5V7.5H12V8.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFillAddCircle);
export default __webpack_public_path__ + "static/media/ic-fill-add-circle.245d1d7283e63fb4553a34502d5f2162.svg";
export { ForwardRef as ReactComponent };